// components/SatelliteMap.jsx
import React, { useState } from "react";
import {
  GoogleMap,
  Marker,
  StreetViewPanorama,
  useJsApiLoader,
} from "@react-google-maps/api";

// Your container style
const containerStyle = {
  width: "100%",
  height: "300px",
};

// Optional: night mode style (you can customize)
const nightModeStyles = [
  {
    elementType: "geometry",
    stylers: [{ color: "#212121" }],
  },
  {
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#212121" }],
  },
  {
    featureType: "all",
    elementType: "all",
    stylers: [{ saturation: -100 }],
  },
];

const SatelliteMap = ({ lat, lng }) => {
  const [streetViewVisible, setStreetViewVisible] = useState(false);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCLm1sHPEZGlSqLnC85i2ESLn09u0xJD0E", // Use .env in prod
  });

  const center = {
    lat: parseFloat(lat),
    lng: parseFloat(lng),
  };

  if (!isLoaded) return <div>Loading Map...</div>;

  return (
    <div className="attachment1 p-3" style={{ background: "rgb(31, 41, 53)" }}>
      <div className="heading-content p-1">
        <h5>Location</h5>
      </div>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        options={{
          mapTypeId: "satellite",
          styles: nightModeStyles,
          streetViewControl: true,
          mapTypeControl: false,
        }}
        onClick={() => setStreetViewVisible(!streetViewVisible)}
      >
        <Marker position={center} />

        {streetViewVisible && (
          <StreetViewPanorama
            position={center}
            visible={true}
            options={{
              pov: { heading: 100, pitch: 0 },
              zoom: 1,
            }}
          />
        )}
      </GoogleMap>
    </div>
  );
};

export default SatelliteMap;
